import React from 'react';
import { CircularProgress } from '@material-ui/core';
import NavigationMenu from '../../images/navigation_menu.png';

export default function LoadingScreen() {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '5vh'
        }}
      >
        <div style={{ fontSize: 32, marginRight: 16 }}>
          Loading the Virtual Project Office...
        </div>
        <CircularProgress color="secondary"></CircularProgress>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          style={{ width: '50vw', borderRadius: 25 }}
          alt="navigation-menu"
          src={NavigationMenu}
        ></img>
      </div>
    </div>
  );
}
